module.exports = __webpack_public_path__ + "img/1f3af.0f5b815.svg";